import { motion } from "framer-motion";
import { TIMELINE } from "@/data/content";

export function ProgrammeTimeline() {
  return (
    <div className="relative" data-testid="programme-timeline">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {TIMELINE.map((step, i) => (
          <motion.div
            key={step}
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.09 }}
            className="relative flex flex-col items-center text-center"
          >
            <div className="flex h-14 w-14 items-center justify-center rounded-full border-2 border-[#D4AF37] bg-[#0A1E4E] font-mono text-sm font-bold text-[#D4AF37]">
              0{i + 1}
            </div>
            <span className="mt-3 text-sm font-bold uppercase tracking-wide text-[#0A1E4E]">{step}</span>
            {i < TIMELINE.length - 1 && (
              <span className="absolute right-[-0.75rem] top-7 hidden lg:block text-[#D4AF37]">→</span>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
}
